const fetchJson = async (url, opts = {}) => {
  if (!opts.headers) {
    opts.headers = {};
  }
  opts.headers["Accept"] = "application/json";
  const res = await fetch(url, opts);
  const json = await res.json();
  return json;
};
const postJson = async (url, data, opts = {}) => {
  if (!opts.method) {
    opts.method = "POST";
  }
  if (!opts.headers) {
    opts.headers = {};
  }
  opts.headers["Content-Type"] = "application/json";
  opts.body = JSON.stringify(data);
  return fetchJson(url, opts);
};
const uploadFile = (url, fileObj) => {
  const body = new FormData();
  body.append("file", fileObj);
  return fetchJson(url, { method: "POST", body });
};
var fetch$1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  fetchJson,
  postJson,
  uploadFile
}, Symbol.toStringTag, { value: "Module" }));
function _isPlaceholder(a) {
  return a != null && typeof a === "object" && a["@@functional/placeholder"] === true;
}
function _curry1(fn) {
  return function f1(a) {
    if (arguments.length === 0 || _isPlaceholder(a)) {
      return f1;
    } else {
      return fn.apply(this, arguments);
    }
  };
}
function _curry2(fn) {
  return function f2(a, b) {
    switch (arguments.length) {
      case 0:
        return f2;
      case 1:
        return _isPlaceholder(a) ? f2 : _curry1(function(_b) {
          return fn(a, _b);
        });
      default:
        return _isPlaceholder(a) && _isPlaceholder(b) ? f2 : _isPlaceholder(a) ? _curry1(function(_a) {
          return fn(_a, b);
        }) : _isPlaceholder(b) ? _curry1(function(_b) {
          return fn(a, _b);
        }) : fn(a, b);
    }
  };
}
function _arity(n, fn) {
  switch (n) {
    case 0:
      return function() {
        return fn.apply(this, arguments);
      };
    case 1:
      return function(a0) {
        return fn.apply(this, arguments);
      };
    case 2:
      return function(a0, a1) {
        return fn.apply(this, arguments);
      };
    case 3:
      return function(a0, a1, a2) {
        return fn.apply(this, arguments);
      };
    case 4:
      return function(a0, a1, a2, a3) {
        return fn.apply(this, arguments);
      };
    case 5:
      return function(a0, a1, a2, a3, a4) {
        return fn.apply(this, arguments);
      };
    case 6:
      return function(a0, a1, a2, a3, a4, a5) {
        return fn.apply(this, arguments);
      };
    case 7:
      return function(a0, a1, a2, a3, a4, a5, a6) {
        return fn.apply(this, arguments);
      };
    case 8:
      return function(a0, a1, a2, a3, a4, a5, a6, a7) {
        return fn.apply(this, arguments);
      };
    case 9:
      return function(a0, a1, a2, a3, a4, a5, a6, a7, a8) {
        return fn.apply(this, arguments);
      };
    case 10:
      return function(a0, a1, a2, a3, a4, a5, a6, a7, a8, a9) {
        return fn.apply(this, arguments);
      };
    default:
      throw new Error("First argument to _arity must be a non-negative integer no greater than ten");
  }
}
function _curryN(length, received, fn) {
  return function() {
    var combined = [];
    var argsIdx = 0;
    var left = length;
    var combinedIdx = 0;
    while (combinedIdx < received.length || argsIdx < arguments.length) {
      var result;
      if (combinedIdx < received.length && (!_isPlaceholder(received[combinedIdx]) || argsIdx >= arguments.length)) {
        result = received[combinedIdx];
      } else {
        result = arguments[argsIdx];
        argsIdx += 1;
      }
      combined[combinedIdx] = result;
      if (!_isPlaceholder(result)) {
        left -= 1;
      }
      combinedIdx += 1;
    }
    return left <= 0 ? fn.apply(this, combined) : _arity(left, _curryN(length, combined, fn));
  };
}
var curryN = /* @__PURE__ */ _curry2(function curryN2(length, fn) {
  if (length === 1) {
    return _curry1(fn);
  }
  return _arity(length, _curryN(length, [], fn));
});
var curryN$1 = curryN;
function _curry3(fn) {
  return function f3(a, b, c) {
    switch (arguments.length) {
      case 0:
        return f3;
      case 1:
        return _isPlaceholder(a) ? f3 : _curry2(function(_b, _c) {
          return fn(a, _b, _c);
        });
      case 2:
        return _isPlaceholder(a) && _isPlaceholder(b) ? f3 : _isPlaceholder(a) ? _curry2(function(_a, _c) {
          return fn(_a, b, _c);
        }) : _isPlaceholder(b) ? _curry2(function(_b, _c) {
          return fn(a, _b, _c);
        }) : _curry1(function(_c) {
          return fn(a, b, _c);
        });
      default:
        return _isPlaceholder(a) && _isPlaceholder(b) && _isPlaceholder(c) ? f3 : _isPlaceholder(a) && _isPlaceholder(b) ? _curry2(function(_a, _b) {
          return fn(_a, _b, c);
        }) : _isPlaceholder(a) && _isPlaceholder(c) ? _curry2(function(_a, _c) {
          return fn(_a, b, _c);
        }) : _isPlaceholder(b) && _isPlaceholder(c) ? _curry2(function(_b, _c) {
          return fn(a, _b, _c);
        }) : _isPlaceholder(a) ? _curry1(function(_a) {
          return fn(_a, b, c);
        }) : _isPlaceholder(b) ? _curry1(function(_b) {
          return fn(a, _b, c);
        }) : _isPlaceholder(c) ? _curry1(function(_c) {
          return fn(a, b, _c);
        }) : fn(a, b, c);
    }
  };
}
var _isArray = Array.isArray || function _isArray2(val) {
  return val != null && val.length >= 0 && Object.prototype.toString.call(val) === "[object Array]";
};
function _isTransformer(obj) {
  return obj != null && typeof obj["@@transducer/step"] === "function";
}
function _dispatchable(methodNames, transducerCreator, fn) {
  return function() {
    if (arguments.length === 0) {
      return fn();
    }
    var obj = arguments[arguments.length - 1];
    if (!_isArray(obj)) {
      var idx = 0;
      while (idx < methodNames.length) {
        if (typeof obj[methodNames[idx]] === "function") {
          return obj[methodNames[idx]].apply(obj, Array.prototype.slice.call(arguments, 0, -1));
        }
        idx += 1;
      }
      if (_isTransformer(obj)) {
        var transducer = transducerCreator.apply(null, Array.prototype.slice.call(arguments, 0, -1));
        return transducer(obj);
      }
    }
    return fn.apply(this, arguments);
  };
}
var _xfBase = {
  init: function() {
    return this.xf["@@transducer/init"]();
  },
  result: function(result) {
    return this.xf["@@transducer/result"](result);
  }
};
function _arrayFromIterator(iter) {
  var list = [];
  var next;
  while (!(next = iter.next()).done) {
    list.push(next.value);
  }
  return list;
}
function _includesWith(pred, x, list) {
  var idx = 0;
  var len = list.length;
  while (idx < len) {
    if (pred(x, list[idx])) {
      return true;
    }
    idx += 1;
  }
  return false;
}
function _functionName(f) {
  var match = String(f).match(/^function (\w*)/);
  return match == null ? "" : match[1];
}
function _has(prop3, obj) {
  return Object.prototype.hasOwnProperty.call(obj, prop3);
}
function _objectIs(a, b) {
  if (a === b) {
    return a !== 0 || 1 / a === 1 / b;
  } else {
    return a !== a && b !== b;
  }
}
var _objectIs$1 = typeof Object.is === "function" ? Object.is : _objectIs;
var toString = Object.prototype.toString;
var _isArguments = /* @__PURE__ */ function() {
  return toString.call(arguments) === "[object Arguments]" ? function _isArguments2(x) {
    return toString.call(x) === "[object Arguments]";
  } : function _isArguments2(x) {
    return _has("callee", x);
  };
}();
var _isArguments$1 = _isArguments;
var hasEnumBug = !/* @__PURE__ */ {
  toString: null
}.propertyIsEnumerable("toString");
var nonEnumerableProps = ["constructor", "valueOf", "isPrototypeOf", "toString", "propertyIsEnumerable", "hasOwnProperty", "toLocaleString"];
var hasArgsEnumBug = /* @__PURE__ */ function() {
  return arguments.propertyIsEnumerable("length");
}();
var contains = function contains2(list, item) {
  var idx = 0;
  while (idx < list.length) {
    if (list[idx] === item) {
      return true;
    }
    idx += 1;
  }
  return false;
};
var keys$1 = typeof Object.keys === "function" && !hasArgsEnumBug ? /* @__PURE__ */ _curry1(function keys(obj) {
  return Object(obj) !== obj ? [] : Object.keys(obj);
}) : /* @__PURE__ */ _curry1(function keys2(obj) {
  if (Object(obj) !== obj) {
    return [];
  }
  var prop3, nIdx;
  var ks = [];
  var checkArgsLength = hasArgsEnumBug && _isArguments$1(obj);
  for (prop3 in obj) {
    if (_has(prop3, obj) && (!checkArgsLength || prop3 !== "length")) {
      ks[ks.length] = prop3;
    }
  }
  if (hasEnumBug) {
    nIdx = nonEnumerableProps.length - 1;
    while (nIdx >= 0) {
      prop3 = nonEnumerableProps[nIdx];
      if (_has(prop3, obj) && !contains(ks, prop3)) {
        ks[ks.length] = prop3;
      }
      nIdx -= 1;
    }
  }
  return ks;
});
var keys$2 = keys$1;
var type = /* @__PURE__ */ _curry1(function type2(val) {
  return val === null ? "Null" : val === void 0 ? "Undefined" : Object.prototype.toString.call(val).slice(8, -1);
});
var type$1 = type;
function _uniqContentEquals(aIterator, bIterator, stackA, stackB) {
  var a = _arrayFromIterator(aIterator);
  var b = _arrayFromIterator(bIterator);
  function eq(_a, _b) {
    return _equals(_a, _b, stackA.slice(), stackB.slice());
  }
  return !_includesWith(function(b2, aItem) {
    return !_includesWith(eq, aItem, b2);
  }, b, a);
}
function _equals(a, b, stackA, stackB) {
  if (_objectIs$1(a, b)) {
    return true;
  }
  var typeA = type$1(a);
  if (typeA !== type$1(b)) {
    return false;
  }
  if (typeof a["fantasy-land/equals"] === "function" || typeof b["fantasy-land/equals"] === "function") {
    return typeof a["fantasy-land/equals"] === "function" && a["fantasy-land/equals"](b) && typeof b["fantasy-land/equals"] === "function" && b["fantasy-land/equals"](a);
  }
  if (typeof a.equals === "function" || typeof b.equals === "function") {
    return typeof a.equals === "function" && a.equals(b) && typeof b.equals === "function" && b.equals(a);
  }
  switch (typeA) {
    case "Arguments":
    case "Array":
    case "Object":
      if (typeof a.constructor === "function" && _functionName(a.constructor) === "Promise") {
        return a === b;
      }
      break;
    case "Boolean":
    case "Number":
    case "String":
      if (!(typeof a === typeof b && _objectIs$1(a.valueOf(), b.valueOf()))) {
        return false;
      }
      break;
    case "Date":
      if (!_objectIs$1(a.valueOf(), b.valueOf())) {
        return false;
      }
      break;
    case "Error":
      return a.name === b.name && a.message === b.message;
    case "RegExp":
      if (!(a.source === b.source && a.global === b.global && a.ignoreCase === b.ignoreCase && a.multiline === b.multiline && a.sticky === b.sticky && a.unicode === b.unicode)) {
        return false;
      }
      break;
  }
  var idx = stackA.length - 1;
  while (idx >= 0) {
    if (stackA[idx] === a) {
      return stackB[idx] === b;
    }
    idx -= 1;
  }
  switch (typeA) {
    case "Map":
      if (a.size !== b.size) {
        return false;
      }
      return _uniqContentEquals(a.entries(), b.entries(), stackA.concat([a]), stackB.concat([b]));
    case "Set":
      if (a.size !== b.size) {
        return false;
      }
      return _uniqContentEquals(a.values(), b.values(), stackA.concat([a]), stackB.concat([b]));
    case "Arguments":
    case "Array":
    case "Object":
    case "Boolean":
    case "Number":
    case "String":
    case "Date":
    case "Error":
    case "RegExp":
    case "Int8Array":
    case "Uint8Array":
    case "Uint8ClampedArray":
    case "Int16Array":
    case "Uint16Array":
    case "Int32Array":
    case "Uint32Array":
    case "Float32Array":
    case "Float64Array":
    case "ArrayBuffer":
      break;
    default:
      return false;
  }
  var keysA = keys$2(a);
  if (keysA.length !== keys$2(b).length) {
    return false;
  }
  var extendedStackA = stackA.concat([a]);
  var extendedStackB = stackB.concat([b]);
  idx = keysA.length - 1;
  while (idx >= 0) {
    var key = keysA[idx];
    if (!(_has(key, b) && _equals(b[key], a[key], extendedStackA, extendedStackB))) {
      return false;
    }
    idx -= 1;
  }
  return true;
}
var equals = /* @__PURE__ */ _curry2(function equals2(a, b) {
  return _equals(a, b, [], []);
});
var equals$1 = equals;
function _map(fn, functor) {
  var idx = 0;
  var len = functor.length;
  var result = Array(len);
  while (idx < len) {
    result[idx] = fn(functor[idx]);
    idx += 1;
  }
  return result;
}
function _arrayReduce(reducer, acc, list) {
  var index = 0;
  var length = list.length;
  while (index < length) {
    acc = reducer(acc, list[index]);
    index += 1;
  }
  return acc;
}
var XMap = /* @__PURE__ */ function() {
  function XMap2(f, xf) {
    this.xf = xf;
    this.f = f;
  }
  XMap2.prototype["@@transducer/init"] = _xfBase.init;
  XMap2.prototype["@@transducer/result"] = _xfBase.result;
  XMap2.prototype["@@transducer/step"] = function(result, input) {
    return this.xf["@@transducer/step"](result, this.f(input));
  };
  return XMap2;
}();
var _xmap = function _xmap2(f) {
  return function(xf) {
    return new XMap(f, xf);
  };
};
var _xmap$1 = _xmap;
var map = /* @__PURE__ */ _curry2(
  /* @__PURE__ */ _dispatchable(["fantasy-land/map", "map"], _xmap$1, function map2(fn, functor) {
    switch (Object.prototype.toString.call(functor)) {
      case "[object Function]":
        return curryN$1(functor.length, function() {
          return fn.call(this, functor.apply(this, arguments));
        });
      case "[object Object]":
        return _arrayReduce(function(acc, key) {
          acc[key] = fn(functor[key]);
          return acc;
        }, {}, keys$2(functor));
      default:
        return _map(fn, functor);
    }
  })
);
var map$1 = map;
var _isInteger = Number.isInteger || function _isInteger2(n) {
  return n << 0 === n;
};
function _isString(x) {
  return Object.prototype.toString.call(x) === "[object String]";
}
var nth = /* @__PURE__ */ _curry2(function nth2(offset, list) {
  var idx = offset < 0 ? list.length + offset : offset;
  return _isString(list) ? list.charAt(idx) : list[idx];
});
var nth$1 = nth;
var prop = /* @__PURE__ */ _curry2(function prop2(p, obj) {
  if (obj == null) {
    return;
  }
  return _isInteger(p) ? nth$1(p, obj) : obj[p];
});
var prop$1 = prop;
var _isArrayLike = /* @__PURE__ */ _curry1(function isArrayLike(x) {
  if (_isArray(x)) {
    return true;
  }
  if (!x) {
    return false;
  }
  if (typeof x !== "object") {
    return false;
  }
  if (_isString(x)) {
    return false;
  }
  if (x.length === 0) {
    return true;
  }
  if (x.length > 0) {
    return x.hasOwnProperty(0) && x.hasOwnProperty(x.length - 1);
  }
  return false;
});
var _isArrayLike$1 = _isArrayLike;
var symIterator = typeof Symbol !== "undefined" ? Symbol.iterator : "@@iterator";
function _createReduce(arrayReduce, methodReduce, iterableReduce) {
  return function _reduce(xf, acc, list) {
    if (_isArrayLike$1(list)) {
      return arrayReduce(xf, acc, list);
    }
    if (list == null) {
      return acc;
    }
    if (typeof list["fantasy-land/reduce"] === "function") {
      return methodReduce(xf, acc, list, "fantasy-land/reduce");
    }
    if (list[symIterator] != null) {
      return iterableReduce(xf, acc, list[symIterator]());
    }
    if (typeof list.next === "function") {
      return iterableReduce(xf, acc, list);
    }
    if (typeof list.reduce === "function") {
      return methodReduce(xf, acc, list, "reduce");
    }
    throw new TypeError("reduce: list must be array or iterable");
  };
}
function _xArrayReduce(xf, acc, list) {
  var idx = 0;
  var len = list.length;
  while (idx < len) {
    acc = xf["@@transducer/step"](acc, list[idx]);
    if (acc && acc["@@transducer/reduced"]) {
      acc = acc["@@transducer/value"];
      break;
    }
    idx += 1;
  }
  return xf["@@transducer/result"](acc);
}
var bind = /* @__PURE__ */ _curry2(function bind2(fn, thisObj) {
  return _arity(fn.length, function() {
    return fn.apply(thisObj, arguments);
  });
});
var bind$1 = bind;
function _xIterableReduce(xf, acc, iter) {
  var step = iter.next();
  while (!step.done) {
    acc = xf["@@transducer/step"](acc, step.value);
    if (acc && acc["@@transducer/reduced"]) {
      acc = acc["@@transducer/value"];
      break;
    }
    step = iter.next();
  }
  return xf["@@transducer/result"](acc);
}
function _xMethodReduce(xf, acc, obj, methodName) {
  return xf["@@transducer/result"](obj[methodName](bind$1(xf["@@transducer/step"], xf), acc));
}
var _xReduce = /* @__PURE__ */ _createReduce(_xArrayReduce, _xMethodReduce, _xIterableReduce);
var _xReduce$1 = _xReduce;
var XWrap = /* @__PURE__ */ function() {
  function XWrap2(fn) {
    this.f = fn;
  }
  XWrap2.prototype["@@transducer/init"] = function() {
    throw new Error("init not implemented on XWrap");
  };
  XWrap2.prototype["@@transducer/result"] = function(acc) {
    return acc;
  };
  XWrap2.prototype["@@transducer/step"] = function(acc, x) {
    return this.f(acc, x);
  };
  return XWrap2;
}();
function _xwrap(fn) {
  return new XWrap(fn);
}
var reduce = /* @__PURE__ */ _curry3(function(xf, acc, list) {
  return _xReduce$1(typeof xf === "function" ? _xwrap(xf) : xf, acc, list);
});
var reduce$1 = reduce;
function _assoc(prop3, val, obj) {
  if (_isInteger(prop3) && _isArray(obj)) {
    var arr = [].concat(obj);
    arr[prop3] = val;
    return arr;
  }
  var result = {};
  for (var p in obj) {
    result[p] = obj[p];
  }
  result[prop3] = val;
  return result;
}
var isNil = /* @__PURE__ */ _curry1(function isNil2(x) {
  return x == null;
});
var isNil$1 = isNil;
var assocPath = /* @__PURE__ */ _curry3(function assocPath2(path3, val, obj) {
  if (path3.length === 0) {
    return val;
  }
  var idx = path3[0];
  if (path3.length > 1) {
    var nextObj = !isNil$1(obj) && _has(idx, obj) && typeof obj[idx] === "object" ? obj[idx] : _isInteger(path3[1]) ? [] : {};
    val = assocPath2(Array.prototype.slice.call(path3, 1), val, nextObj);
  }
  return _assoc(idx, val, obj);
});
var assocPath$1 = assocPath;
function _cloneRegExp(pattern) {
  return new RegExp(pattern.source, pattern.flags ? pattern.flags : (pattern.global ? "g" : "") + (pattern.ignoreCase ? "i" : "") + (pattern.multiline ? "m" : "") + (pattern.sticky ? "y" : "") + (pattern.unicode ? "u" : "") + (pattern.dotAll ? "s" : ""));
}
function _clone(value, deep, map3) {
  map3 || (map3 = new _ObjectMap());
  if (_isPrimitive(value)) {
    return value;
  }
  var copy = function copy2(copiedValue) {
    var cachedCopy = map3.get(value);
    if (cachedCopy) {
      return cachedCopy;
    }
    map3.set(value, copiedValue);
    for (var key in value) {
      if (Object.prototype.hasOwnProperty.call(value, key)) {
        copiedValue[key] = deep ? _clone(value[key], true, map3) : value[key];
      }
    }
    return copiedValue;
  };
  switch (type$1(value)) {
    case "Object":
      return copy(Object.create(Object.getPrototypeOf(value)));
    case "Array":
      return copy([]);
    case "Date":
      return new Date(value.valueOf());
    case "RegExp":
      return _cloneRegExp(value);
    case "Int8Array":
    case "Uint8Array":
    case "Uint8ClampedArray":
    case "Int16Array":
    case "Uint16Array":
    case "Int32Array":
    case "Uint32Array":
    case "Float32Array":
    case "Float64Array":
    case "BigInt64Array":
    case "BigUint64Array":
      return value.slice();
    default:
      return value;
  }
}
function _isPrimitive(param) {
  var type3 = typeof param;
  return param == null || type3 != "object" && type3 != "function";
}
var _ObjectMap = /* @__PURE__ */ function() {
  function _ObjectMap2() {
    this.map = {};
    this.length = 0;
  }
  _ObjectMap2.prototype.set = function(key, value) {
    const hashedKey = this.hash(key);
    let bucket = this.map[hashedKey];
    if (!bucket) {
      this.map[hashedKey] = bucket = [];
    }
    bucket.push([key, value]);
    this.length += 1;
  };
  _ObjectMap2.prototype.hash = function(key) {
    let hashedKey = [];
    for (var value in key) {
      hashedKey.push(Object.prototype.toString.call(key[value]));
    }
    return hashedKey.join();
  };
  _ObjectMap2.prototype.get = function(key) {
    if (this.length <= 180) {
      for (const p in this.map) {
        const bucket2 = this.map[p];
        for (let i = 0; i < bucket2.length; i += 1) {
          const element = bucket2[i];
          if (element[0] === key) {
            return element[1];
          }
        }
      }
      return;
    }
    const hashedKey = this.hash(key);
    const bucket = this.map[hashedKey];
    if (!bucket) {
      return;
    }
    for (let i = 0; i < bucket.length; i += 1) {
      const element = bucket[i];
      if (element[0] === key) {
        return element[1];
      }
    }
  };
  return _ObjectMap2;
}();
var clone = /* @__PURE__ */ _curry1(function clone2(value) {
  return value != null && typeof value.clone === "function" ? value.clone() : _clone(value, true);
});
var clone$1 = clone;
function _pipe(f, g) {
  return function() {
    return g.call(this, f.apply(this, arguments));
  };
}
function _checkForMethod(methodname, fn) {
  return function() {
    var length = arguments.length;
    if (length === 0) {
      return fn();
    }
    var obj = arguments[length - 1];
    return _isArray(obj) || typeof obj[methodname] !== "function" ? fn.apply(this, arguments) : obj[methodname].apply(obj, Array.prototype.slice.call(arguments, 0, length - 1));
  };
}
var slice = /* @__PURE__ */ _curry3(
  /* @__PURE__ */ _checkForMethod("slice", function slice2(fromIndex, toIndex, list) {
    return Array.prototype.slice.call(list, fromIndex, toIndex);
  })
);
var slice$1 = slice;
var tail = /* @__PURE__ */ _curry1(
  /* @__PURE__ */ _checkForMethod(
    "tail",
    /* @__PURE__ */ slice$1(1, Infinity)
  )
);
var tail$1 = tail;
function pipe() {
  if (arguments.length === 0) {
    throw new Error("pipe requires at least one argument");
  }
  return _arity(arguments[0].length, reduce$1(_pipe, arguments[0], tail$1(arguments)));
}
function _identity(x) {
  return x;
}
var identity = /* @__PURE__ */ _curry1(_identity);
var identity$1 = identity;
var last = /* @__PURE__ */ nth$1(-1);
var last$1 = last;
function _objectAssign(target) {
  if (target == null) {
    throw new TypeError("Cannot convert undefined or null to object");
  }
  var output = Object(target);
  var idx = 1;
  var length = arguments.length;
  while (idx < length) {
    var source = arguments[idx];
    if (source != null) {
      for (var nextKey in source) {
        if (_has(nextKey, source)) {
          output[nextKey] = source[nextKey];
        }
      }
    }
    idx += 1;
  }
  return output;
}
var _objectAssign$1 = typeof Object.assign === "function" ? Object.assign : _objectAssign;
var is = /* @__PURE__ */ _curry2(function is2(Ctor, val) {
  return val instanceof Ctor || val != null && (val.constructor === Ctor || Ctor.name === "Object" && typeof val === "object");
});
var is$1 = is;
var paths = /* @__PURE__ */ _curry2(function paths2(pathsArray, obj) {
  return pathsArray.map(function(paths3) {
    var val = obj;
    var idx = 0;
    var p;
    while (idx < paths3.length) {
      if (val == null) {
        return;
      }
      p = paths3[idx];
      val = _isInteger(p) ? nth$1(p, val) : val[p];
      idx += 1;
    }
    return val;
  });
});
var paths$1 = paths;
var path = /* @__PURE__ */ _curry2(function path2(pathAr, obj) {
  return paths$1([pathAr], obj)[0];
});
var path$1 = path;
var mergeLeft = /* @__PURE__ */ _curry2(function mergeLeft2(l, r) {
  return _objectAssign$1({}, r, l);
});
var mergeLeft$1 = mergeLeft;
var mergeRight = /* @__PURE__ */ _curry2(function mergeRight2(l, r) {
  return _objectAssign$1({}, l, r);
});
var mergeRight$1 = mergeRight;
var omit = /* @__PURE__ */ _curry2(function omit2(names, obj) {
  var result = {};
  var index = {};
  var idx = 0;
  var len = names.length;
  while (idx < len) {
    index[names[idx]] = 1;
    idx += 1;
  }
  for (var prop3 in obj) {
    if (!index.hasOwnProperty(prop3)) {
      result[prop3] = obj[prop3];
    }
  }
  return result;
});
var omit$1 = omit;
var sortBy = /* @__PURE__ */ _curry2(function sortBy2(fn, list) {
  return Array.prototype.slice.call(list, 0).sort(function(a, b) {
    var aa = fn(a);
    var bb = fn(b);
    return aa < bb ? -1 : aa > bb ? 1 : 0;
  });
});
var sortBy$1 = sortBy;
var round = curryN$1(2, (precision, x) => Math.round(x * Math.pow(10, precision)) / Math.pow(10, precision));
const DOT_REGEXP = new RegExp(/\.+/);
var parseFloat$1 = (x, fallback = 0) => {
  x = parseFloat(x.toString().replace(DOT_REGEXP, ".").trim());
  return isNaN(x) ? fallback : x;
};
const million = Math.pow(10, 10);
const formatNumeric$1 = (n, { precision } = {}) => {
  n = Math.round(n * 100 * million) / million;
  return String(precision === void 0 ? n : parseFloat$1(n.toFixed(precision)));
};
const parseNumeric$1 = (display, { precision } = {}) => {
  const result = parseFloat$1(display) / 100;
  return precision === void 0 ? result : round(precision, result);
};
const format$1 = pipe(formatNumeric$1, (value) => `${value}%`);
const parse$1 = (value, opts) => parseNumeric$1(value.replace("%", ""), opts);
var percent = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  formatNumeric: formatNumeric$1,
  parseNumeric: parseNumeric$1,
  format: format$1,
  parse: parse$1
}, Symbol.toStringTag, { value: "Module" }));
var commaFormat = (x) => String(x).split("").reverse().reduce((acc, n, i) => n + (i && !(i % 3) ? "," : "") + acc).replace("-,", "-");
let symbol = "$";
const getSymbol = () => symbol;
const setSymbol = (s) => {
  symbol = s;
};
const formatNumeric = (x) => {
  const [dollars, cents] = parseFloat$1(x / 100).toFixed(2).split(".");
  return [commaFormat(dollars), cents].join(".");
};
const parseNumeric = (display) => Math.round(parseFloat$1(display.replace(/,/g, "")) * 100);
const format = (cents) => cents >= 0 ? `${symbol}${formatNumeric(cents)}` : `-${symbol}${formatNumeric(Math.abs(cents))}`;
const parse = (display) => parseNumeric(display.replace(symbol, ""));
const formatRounded = (cents) => format(cents).slice(0, -3);
const parseRounded = (display) => parse(`${display}.00`);
const formatK = (cents) => {
  if (cents < 1e6) {
    return formatRounded(cents);
  }
  const k = formatRounded(cents / 1e3);
  const h = Math.floor(cents % 1e5 / 1e4);
  return h ? `${k}.${h}k` : `${k}k`;
};
var currency = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  getSymbol,
  setSymbol,
  formatNumeric,
  parseNumeric,
  format,
  parse,
  formatRounded,
  parseRounded,
  formatK
}, Symbol.toStringTag, { value: "Module" }));
const fake = {};
let isFake = false;
let storage;
try {
  storage = localStorage;
} catch (e) {
  isFake = true;
  storage = {
    getItem: (k) => fake[k] || null,
    setItem: (k, v) => {
      fake[k] = v;
    },
    removeItem: (k) => {
      delete fake[k];
    }
  };
}
const clear = ({ keep, only } = {}) => {
  if (keep && only) {
    throw new Error("keep and only are mutually exclusive");
  }
  for (const k in isFake ? fake : storage) {
    if (keep && !keep.includes(k)) {
      storage.removeItem(k);
    }
    if (only && only.includes(k)) {
      storage.removeItem(k);
    }
    if (!keep && !only) {
      storage.removeItem(k);
    }
  }
};
const setItem = (k, v) => storage.setItem(k, v);
const hasItem = (k) => Object.hasOwn(storage, k) || Object.hasOwn(fake, k);
const getItem = (k) => storage.getItem(k);
const setJson = (k, v) => setItem(k, JSON.stringify(v));
const getJson = (k) => {
  const v = getItem(k);
  return v === null ? v : JSON.parse(v);
};
const keys3 = () => Object.keys(isFake ? fake : storage);
const cursor = (key, initialState = null) => {
  if (!hasItem(key)) {
    setJson(key, initialState);
  }
  return {
    key,
    initialState,
    set: (v) => setJson(key, v),
    get: () => getJson(key)
  };
};
var storage$1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  clear,
  setItem,
  hasItem,
  getItem,
  setJson,
  getJson,
  keys: keys3,
  cursor
}, Symbol.toStringTag, { value: "Module" }));
var anyProp = (x) => x[Object.keys(x)[0]];
var argsToObj = (ks, ...a) => (...b) => {
  const combined = a.concat(b);
  return Object.fromEntries(ks.map((k, i) => [k, combined[i]]));
};
var avg = (xs) => xs.length > 0 ? xs.reduce((s, x) => s + x, 0) / xs.length : 0;
var throttle = (t, f) => {
  let args;
  let timeout;
  return (...thisArgs) => {
    args = thisArgs;
    if (!timeout) {
      timeout = setTimeout(async () => {
        await f(...args);
        timeout = null;
      }, t);
    }
  };
};
var batch = (t, f) => {
  const xs = [];
  const cb = throttle(t, () => xs.length > 0 && f(xs.splice(0)));
  return (x) => {
    xs.push(x);
    cb();
  };
};
var between = curryN$1(3, (low, high, n) => n > low && n < high);
var bytes = (n, unit) => {
  switch (unit.toLowerCase()) {
    case "kb":
      return n * 1024;
    case "mb":
      return n * 1024 * 1024;
    case "gb":
      return n * 1024 * 1024 * 1024;
    case "tb":
      return n * 1024 * 1024 * 1024 * 1024;
    case "pb":
      return n * 1024 * 1024 * 1024 * 1024 * 1024;
    default:
      throw new Error(`${unit} is not a valid bytes unit`);
  }
};
function* chain(...generators) {
  for (const g of generators) {
    yield* g;
  }
}
var choice = (xs) => xs[Math.floor(Math.random() * xs.length)];
var chunk = (chunkLength, coll) => {
  const result = [];
  let current = [];
  coll.forEach((item) => {
    if (current.length < chunkLength) {
      current.push(item);
    }
    if (current.length === chunkLength) {
      result.push(current);
      current = [];
    }
  });
  if (current.length > 0) {
    result.push(current);
  }
  return result;
};
var clamp = ([min, max], n) => Math.min(max, Math.max(min, n));
var closure = (f) => f();
var concatAll = (lists = []) => lists.reduce((a, b) => a.concat(b), []);
var copyProp = curryN$1(3, (fromKey, toKey, obj) => ({ ...obj, [toKey]: obj[fromKey] }));
var count = (x) => keys$2(x).length;
var createMap = curryN$1(2, (k, xs) => {
  const r = {};
  for (let i = 0; i < xs.length; i++) {
    r[xs[i][k]] = xs[i];
  }
  return r;
});
var createMapOf = curryN$1(3, (k, vk, xs) => {
  const r = {};
  for (let i = 0; i < xs.length; i++) {
    r[xs[i][k]] = xs[i][vk];
  }
  return r;
});
var defer = () => {
  let resolve;
  let reject;
  const promise = new Promise((res, rej) => {
    resolve = res;
    reject = rej;
  });
  return Object.assign(promise, {
    resolve,
    reject
  });
};
var diffArrays = (a, b) => {
  const added = b.filter((x) => !a.includes(x));
  const removed = a.filter((x) => !b.includes(x));
  const mutual = a.filter((x) => b.includes(x));
  return [removed, added, mutual];
};
var diffObjects = (obj1, obj2) => {
  const diff = [];
  [...new Set(Object.keys(obj1).concat(Object.keys(obj2)))].forEach((key) => {
    if (obj1[key] === void 0 && obj2[key] !== void 0) {
      diff.push([`key "${key}" is new in object 2. New value:`, obj2[key]]);
    } else if (obj2[key] === void 0 && obj1[key] !== void 0) {
      diff.push([`key "${key}" was removed in object 2. Old value:`, obj1[key]]);
    } else if (!equals$1(obj1[key], obj2[key])) {
      diff.push([
        `key "${key}" was changed in object 2. Old value: `,
        obj1[key],
        "New value:",
        obj2[key]
      ]);
    } else if (obj1[key] !== obj2[key]) {
      diff.push([`key "${key}" was changed in object 2 (by identity, but not value)`]);
    }
  });
  return diff;
};
var difference = (a, b) => new Set(Array.from(a).filter((x) => !b.has(x)));
var displayList = (xs, conj = "and", n = 6) => {
  if (xs.length === 0) {
    return "";
  } else if (xs.length === 1) {
    return xs[0];
  } else if (xs.length === 2) {
    return `${xs[0]} ${conj} ${xs[1]}`;
  } else if (xs.length > n + 2) {
    return `${xs.slice(0, n).join(", ")}, ${conj} ${xs.length - n} others`;
  }
  return `${xs.slice(0, -1).join(", ")}, ${conj} ${last$1(xs)}`;
};
var doPipe = (x, fs) => fs.reduce((v, f) => f(v), x);
var doto = (x, f) => f(x);
var ellipsize = (s, l, suffix = "...") => {
  if (s.length < l * 1.1) {
    return s;
  }
  while (s.length > l && s.includes(" ")) {
    s = s.split(" ").slice(0, -1).join(" ");
  }
  return s + suffix;
};
var ensurePlural = (x) => x instanceof Array ? x : [x];
var ffirst = (list) => {
  var _a;
  return (_a = list == null ? void 0 : list[0]) == null ? void 0 : _a[0];
};
var fillArray = (length, x) => map$1(() => x, new Array(length));
var fillKeys = curryN$1(2, (ks, x) => {
  const r = {};
  for (let i = 0; i < ks.length; i++) {
    r[ks[i]] = clone$1(x);
  }
  return r;
});
var filterKeys = curryN$1(2, (f, x) => {
  const r = {};
  for (const k in x) {
    if (f(k)) {
      r[k] = x[k];
    }
  }
  return r;
});
var filterVals = curryN$1(2, (f, x) => {
  const r = {};
  for (const k in x) {
    if (f(x[k])) {
      r[k] = x[k];
    }
  }
  return r;
});
const findObjPair = (f, x) => {
  const entries = Object.entries(x);
  for (let i = 0; i < entries.length; i++) {
    const [k, v] = entries[i];
    if (f(v, k)) {
      return [k, v];
    }
  }
  return null;
};
var findObjPair$1 = curryN$1(2, findObjPair);
var findObjKey = curryN$1(2, (f, x) => {
  const pair = findObjPair(f, x);
  return pair == null ? void 0 : pair[0];
});
var findObjVal = curryN$1(2, (f, x) => {
  const pair = findObjPair(f, x);
  return pair == null ? void 0 : pair[1];
});
var first = (list) => Array.from(list || [])[0];
var flatMap = curryN$1(2, (f, xs) => xs.flatMap(f));
var forEachObj = curryN$1(2, (f, x) => Object.entries(x).forEach(([k, v]) => f(v, k)));
var getTimezone = () => new Date().toString().match(/GMT[^\s]+/);
var hash = (s) => Math.abs(s.split("").reduce((a, b) => (a << 5) - a + b.charCodeAt(0) | 0, 0));
var initArray = (length, x) => map$1(x, new Array(length));
var intersperseWith = curryN$1(2, (f, xs) => {
  const init = [];
  return xs.reduce((r, x, i) => r.length ? r.concat([f(x, i), x]) : r.concat(x), init);
});
var invert = (outer) => {
  const r = [];
  outer.forEach((inner, i) => inner.forEach((value, j) => {
    r[j] = r[j] || [];
    r[j][i] = value;
  }));
  return r;
};
var isObject = (x) => is$1(Object, x) && !is$1(Array, x);
var isPojo = (x) => prop$1("constructor", x) === Object;
var isUrl = (url) => {
  try {
    return Boolean(new URL(url));
  } catch (e) {
    return false;
  }
};
var logarithm = (base, n) => Math.log(n) / Math.log(base);
const mapObj = (kf, vf, x) => {
  const r = {};
  for (const k in x) {
    r[kf(k)] = vf(x[k]);
  }
  return r;
};
var mapObj$1 = curryN$1(3, mapObj);
var mapKeys = curryN$1(2, (f, x) => mapObj$1(f, identity$1, x));
var mapVals = curryN$1(2, (f, x) => mapObj(identity$1, f, x));
var mergeLeftPath = curryN$1(3, (p, v, x) => assocPath$1(p, mergeLeft$1(path$1(p, x), v), x));
var mergeLeftIn = curryN$1(3, (k, v, x) => mergeLeftPath([k], v, x));
var mergeRightPath = curryN$1(3, (p, v, x) => assocPath$1(p, mergeRight$1(path$1(p, x), v), x));
var mergeRightIn = curryN$1(3, (k, v, x) => mergeRightPath([k], v, x));
var milliseconds = (n, unit) => {
  switch (unit.toLowerCase()) {
    case "second":
      return n * 1e3;
    case "minute":
      return n * 1e3 * 60;
    case "hour":
      return n * 1e3 * 60 * 60;
    case "day":
      return n * 1e3 * 60 * 60 * 24;
    case "week":
      return n * 1e3 * 60 * 60 * 24 * 7;
    default:
      throw new Error(`${unit} is not a valid unit`);
  }
};
function modifyKeysRecursive(f, x) {
  if (Array.isArray(x)) {
    return x.map((v) => modifyKeysRecursive(f, v));
  }
  if (isPojo(x)) {
    return mapObj$1(f, (v) => modifyKeysRecursive(f, v), x);
  }
  return x;
}
var modifyKeysRecursive$1 = curryN$1(2, modifyKeysRecursive);
const modifyValsRecursive = (match, modify, x) => {
  if (match(x)) {
    return modify(x);
  }
  if (Array.isArray(x)) {
    return x.map((item) => modifyValsRecursive(match, modify, item));
  }
  if (isPojo(x)) {
    return mapVals((v) => modifyValsRecursive(match, modify, v), x);
  }
  return x;
};
var modifyValsRecursive$1 = curryN$1(3, modifyValsRecursive);
var moveProp = curryN$1(3, (fromKey, toKey, obj) => omit$1([fromKey], copyProp(fromKey, toKey, obj)));
var noop = () => void 0;
const noopPromise = { then: () => noopPromise, catch: () => noopPromise };
var parseInt$1 = (x, fallback = 0) => parseInt(parseFloat$1(x, fallback).toString(), 10);
var pickVals = curryN$1(2, (ks, x) => ks.map((k) => x[k]));
var pluralize = (n, label, pluralLabel) => n === 1 ? label : pluralLabel || `${label}s`;
var poll = (t = 100, f) => new Promise((resolve) => {
  (function tryIt() {
    const r = f();
    if (r) {
      resolve(r);
    } else {
      setTimeout(tryIt, t);
    }
  })();
});
var quantify = (n, label, pluralLabel) => `${n} ${pluralize(n, label, pluralLabel)}`;
var randomId = () => Math.random().toString().slice(2);
var randomInt = (min = 0, max = 9) => min + Math.round(Math.random()) * (max - min);
var range = (a, b, step = 1) => {
  const r = [];
  for (let i = a; i < b; i += step) {
    r.push(i);
  }
  return r;
};
var renameProp = curryN$1(3, (a, b, x) => ({
  ...omit$1([a], x),
  [b]: x[a]
}));
var safeDivide = (a, b) => b === 0 ? 0 : a / b;
const summarize = (target, depth = 4) => {
  if (depth === 0 && (is$1(Array, target) || is$1(Object, target))) {
    return `<${typeof target}>`;
  }
  if (is$1(Array, target)) {
    target = target.map((x) => summarize(x, depth - 1));
    return target.length < 3 ? `[${target.join(", ")}]` : `[${target.slice(0, 2).join(", ")}, ...and ${target.length - 3} more]`;
  }
  if (is$1(Object, target)) {
    const pairs = [];
    for (const k in target) {
      pairs.push(`${k}: ${summarize(target[k], depth - 1)}`);
    }
    return `{${pairs.join(", ")}}`;
  }
  if (is$1(Symbol, target)) {
    return target.toString();
  }
  return JSON.stringify(target);
};
const DATE = "^[0-9]{4}-(?:0[1-9]|1[0-2])-(?:0[1-9]|[1-2][0-9]|3[0-1])$";
const TIME = "^T(?:[0-1][0-9]|2[0-3]):[0-5][0-9]:[0-5][0-9].[0-9]{3}Z$";
const DATETIME = DATE.slice(0, -1) + TIME.slice(1);
const UUID = "^[a-fA-F0-9]{8}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{12}$";
const reprType = (x) => {
  const t = typeof x;
  if (["undefined", "boolean"].indexOf(t) !== -1) {
    return t;
  } else if (t === "number" && isNaN(x)) {
    return "NaN";
  } else if (x === null) {
    return "null";
  } else if (x.constructor.name === "Function") {
    return x.name;
  }
  return x.constructor.name;
};
const schemaError = (code, path3, extra) => ({ code, path: path3, ...extra });
class Schema {
  constructor(type3, meta = {}) {
    Object.assign(this, { type: type3, ...meta });
  }
}
const allTypes = {};
const defType = (name, { typeIsValid, iterTypeErrors: iterTypeErrors4 }) => {
  allTypes[name] = {
    name,
    schema: new Schema(name),
    create: (meta) => new Schema(name, meta),
    typeIsValid,
    iterTypeErrors: iterTypeErrors4
  };
};
const normalize = (schema2) => {
  if (is$1(Schema, schema2)) {
    return schema2;
  }
  if (is$1(String, schema2) && allTypes[schema2]) {
    return new Schema(schema2);
  }
  if (is$1(Array, schema2)) {
    return new Schema("arr", { items: schema2[0] });
  }
  if (!is$1(Function, schema2) && is$1(Object, schema2)) {
    return new Schema("obj", { properties: schema2 });
  }
  throw new Error(`Could not normalize "${reprType(schema2)}"`);
};
const cloneSchema = (schema2, meta) => {
  const { type: type3, ...normalizedSchema } = normalize(schema2);
  return new Schema(type3, { ...normalizedSchema, ...meta });
};
const ERROR_CODE = {
  TYPE_ERROR: "schema/type-error",
  MISSING_KEY: "schema/missing-key",
  MISSING_VALUE: "schema/missing-value",
  MIN_LENGTH: "schema/min-length",
  ENUM: "schema/enum"
};
function* iterErrors(schema2, data, path3) {
  schema2 = normalize(schema2);
  const config = allTypes[schema2.type];
  if (!config) {
    throw new Error(`Invalid schema type ${summarize(schema2.type)}`);
  }
  const { typeIsValid, iterTypeErrors: iterTypeErrors4 } = config;
  if (!typeIsValid(data)) {
    yield schemaError(ERROR_CODE.TYPE_ERROR, path3, {
      expected: schema2.type,
      actual: reprType(data),
      message: `${summarize(data)} is not an instance of ${schema2.type}`
    });
  }
  if (schema2.enum && !schema2.enum.includes(data)) {
    const summary = schema2.enum.map(summarize);
    yield schemaError(ERROR_CODE.ENUM, path3, {
      expected: summary,
      actual: reprType(data),
      message: `${summarize(data)} is not one of ${summary}`
    });
  }
  if (iterTypeErrors4) {
    for (const error of iterTypeErrors4(schema2, data, path3)) {
      yield error;
    }
  }
}
function getError(schema2, data, path3 = []) {
  const errors = iterErrors(schema2, data, path3);
  let result;
  do {
    result = errors.next();
  } while (!result.done && !result.value);
  return result.done ? null : result.value;
}
defType("nil", {
  typeIsValid: (v) => v === null
});
defType("any", {
  typeIsValid: (v) => true
});
defType("int", {
  typeIsValid: (v) => is$1(Number, v) && v % 1 === 0
});
defType("num", {
  typeIsValid: (v) => is$1(Number, v)
});
defType("str", {
  typeIsValid: (v) => is$1(String, v),
  iterTypeErrors: function* iterTypeErrors(schema2, data, path3) {
    if (schema2.minLength && data.length < schema2.minLength) {
      yield schemaError(ERROR_CODE.MIN_LENGTH, path3, {
        message: `${last$1(path3)} must be at least ${schema2.minLength} characters long`
      });
    }
  }
});
defType("bool", {
  typeIsValid: (v) => is$1(Boolean, v)
});
defType("true", {
  typeIsValid: (v) => v === true
});
defType("false", {
  typeIsValid: (v) => v === false
});
defType("uuid", {
  typeIsValid: (v) => is$1(String, v) && Boolean(v.match(UUID))
});
defType("datetime", {
  typeIsValid: (v) => is$1(Date, v) || is$1(String, v) && Boolean(v.match(DATETIME))
});
defType("arr", {
  typeIsValid: (v) => is$1(Array, v),
  iterTypeErrors: function* iterTypeErrors2(schema2, data, path3) {
    for (let i = 0; i < data.length; i++) {
      for (const error of iterErrors(schema2.items, data[i], path3.concat(i))) {
        yield error;
      }
    }
  }
});
defType("obj", {
  typeIsValid: (v) => is$1(Object, v),
  iterTypeErrors: function* iterTypeErrors3(schema2, data, path3) {
    for (const k of schema2.requiredKeys || []) {
      if (data[k] === void 0) {
        yield schemaError(ERROR_CODE.MISSING_KEY, path3.concat(k), {
          expected: "any",
          actual: "undefined",
          message: `${k} is a required key`
        });
      }
    }
    for (const k of schema2.requiredValues || []) {
      if (isNil$1(data[k])) {
        yield schemaError(ERROR_CODE.MISSING_VALUE, path3.concat(k), {
          expected: "any",
          actual: reprType(data[k]),
          message: `${k} is a required value`
        });
      }
    }
    for (const k in schema2.properties || {}) {
      if (!isNil$1(data[k])) {
        for (const error of iterErrors(schema2.properties[k], data[k], path3.concat(k))) {
          yield error;
        }
      }
    }
    if (schema2.closed) {
      for (const k in data) {
        if (!schema2.properties[k]) {
          yield schemaError(ERROR_CODE.EXTRA_KEY, path3.concat(k), {
            expected: "undefined",
            actual: reprType(data[k]),
            message: `${k} is not an allowed key`
          });
        }
      }
    }
  }
});
var schema = new Proxy(
  {
    ...ERROR_CODE,
    arr: (items, meta) => new Schema("arr", { items, ...meta }),
    obj: (properties, meta) => new Schema("obj", { properties, ...meta }),
    open: (schema2) => cloneSchema(schema2, { closed: false }),
    closed: (schema2) => cloneSchema(schema2, { closed: true }),
    strict: (schema2) => {
      const normalizedSchema = normalize(schema2);
      const requiredKeys = Object.keys(normalizedSchema.properties);
      return cloneSchema(normalizedSchema, { requiredKeys });
    },
    getError,
    iterErrors
  },
  {
    get(target, name) {
      if (target[name]) {
        return target[name];
      }
      const isCapitalized = Boolean(name.match(/^[A-Z][a-z]+$/));
      const T = allTypes[name.toLowerCase()];
      if (!T) {
        throw new Error(`Invalid schema property ${name}`);
      }
      return isCapitalized ? T.schema : T.create;
    }
  }
);
var seconds = (n, unit) => {
  switch (unit.toLowerCase()) {
    case "minute":
      return n * 60;
    case "hour":
      return n * 60 * 60;
    case "day":
      return n * 60 * 60 * 24;
    case "week":
      return n * 60 * 60 * 24 * 7;
    default:
      throw new Error(`${unit} is not a valid unit`);
  }
};
var shuffle = (xs) => sortBy$1(() => Math.random() > 0.5, xs);
var sleep = (t) => new Promise((resolve) => setTimeout(resolve, t));
var splice = curryN$1(3, (i, n, v) => v.slice(0, i).concat(v.slice(i + n)));
var stackedPromise = () => {
  let latest;
  return function track(x) {
    const cur = Promise.resolve(x);
    latest = cur;
    const guard = (cb) => (result) => cur === latest ? cb(result) : track(latest);
    return Promise.resolve(cur).then(guard((v) => Promise.resolve(v)), guard((v) => Promise.reject(v)));
  };
};
var sumProp = curryN$1(2, (k, xs) => {
  let r = 0;
  for (let i = 0; i < xs.length; i += 1) {
    r += xs[i][k];
  }
  return r;
});
var switcher = (k, m) => m[k] || m.default;
var switcherFn = (k, m) => switcher(k, m)();
var tap = (f) => (v) => {
  f(v);
  return v;
};
var thrower = (m) => () => {
  throw new Error(m);
};
var toSnake = (x) => x.replace(/[-_ ]+/g, "_").replace(/(^_)_*([A-Z][a-z]+)/g, "$1_$2").replace(/\.([A-Z])/g, "_$1").toLowerCase();
var toPascal = (x) => toSnake(x).split("_").map(([a, ...w]) => [(a || "").toUpperCase(), ...w].join("")).join("");
var toCamel = (x) => {
  const [first2, ...rest] = toPascal(x);
  return (first2 || "").toLowerCase() + rest.join("");
};
var toKebab = (x) => toSnake(x).replace(/_/g, "-");
var toScreamingSnake = (x) => toSnake(x).toUpperCase();
var toTitle = (x) => toSnake(x).split("_").map(([a, ...w]) => [(a || "").toUpperCase(), ...w].join("")).join(" ");
function tryFunc(f, onError = (_) => {
}) {
  try {
    const r = f();
    if (is$1(Promise, r)) {
      return r.catch((e) => {
        onError(e);
        return null;
      });
    } else {
      return r;
    }
  } catch (e) {
    onError(e);
  }
  return null;
}
var ucFirst = (x) => x.slice(0, 1).toUpperCase() + x.slice(1);
var union = (...sets) => new Set(sets.flatMap((s) => Array.from(s)));
const updatePath = (p, f, x) => {
  const valueAtPath = path$1(p, x);
  return assocPath$1(p, f(valueAtPath), x);
};
var updatePath$1 = curryN$1(3, updatePath);
var updateIn = curryN$1(3, (k, f, x) => updatePath([k], f, x));
export { currency as Currency, fetch$1 as Fetch, percent as Percent, schema as Schema, storage$1 as Storage, anyProp, argsToObj, avg, batch, between, bytes, chain, choice, chunk, clamp, closure, commaFormat, concatAll, copyProp, count, createMap, createMapOf, defer, diffArrays, diffObjects, difference, displayList, doPipe, doto, ellipsize, ensurePlural, ffirst, fillArray, fillKeys, filterKeys, filterVals, findObjKey, findObjPair$1 as findObjPair, findObjVal, first, flatMap, forEachObj, getTimezone, hash, initArray, intersperseWith, invert, isObject, isPojo, isUrl, logarithm, mapKeys, mapObj$1 as mapObj, mapVals, mergeLeftIn, mergeLeftPath, mergeRightIn, mergeRightPath, milliseconds, modifyKeysRecursive$1 as modifyKeysRecursive, modifyValsRecursive$1 as modifyValsRecursive, moveProp, noop, noopPromise, parseFloat$1 as parseFloat, parseInt$1 as parseInt, pickVals, pluralize, poll, quantify, randomId, randomInt, range, renameProp, round, safeDivide, seconds, shuffle, sleep, splice, stackedPromise, sumProp, summarize, switcher, switcherFn, tap, throttle, thrower, toCamel, toKebab, toPascal, toScreamingSnake, toSnake, toTitle, tryFunc, ucFirst, union, updateIn, updatePath$1 as updatePath };
